import { useMemo, useCallback } from 'react';
import { pick } from 'ramda';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as actions from '../store/actions';
import { useDynamicReducerSelector, useDynamicReducerDispatch } from '../store';

export const useLoadMore = () => {
    const translate = useComponentTranslations();
    const dispatch = useDynamicReducerDispatch();
    const { page: { nextPageId }, isLoading } = useDynamicReducerSelector(pick(['page', 'isLoading']));
    const useGetNextPage = useCallback((): void => dispatch(actions.loadNextPage()), [dispatch]);

    return useMemo(() => nextPageId ?
        {
            title: translate('loadMore'),
            onClick: useGetNextPage,
            disabled: isLoading
        } : null, [translate, useGetNextPage, isLoading, nextPageId]);
};
